const tooltips = {
    cmsS: 'cmdSTooltip',
    zoomTree: 'zoomTreeTooltip',
    definitionNav: 'definitionNavTooltip'
};

export default tooltips;
